module.exports = __webpack_public_path__ + "media/images/logotype_slogan-6e08d9c3916e86a3712a61bd74362ea9.svg";